<template>
  <div>
    <el-card>
      <el-tabs :value="tabName" type="border-card">
        <el-tab-pane name="GnralBalance" label="Balance General">
          <!--style="float: right"-->
          <el-row type="flex" justify="end">
            <yearcomponent @change="handler_year" />

            <el-select
              v-if="valueMoney == 'RD'"
              v-model="valueCompanys"
              v-bind="$attrs"
              size="mini"
              placeholder="Select"
              v-loading="loading"
            >
              <el-option
                v-for="item in companysRD"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>

            <el-select
              v-else
              v-model="valueCompanys"
              v-bind="$attrs"
              size="mini"
              placeholder="Select"
              v-loading="loading"
            >
              <el-option
                v-for="item in companysUSA"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>

            <el-select
              v-model="valueMoney"
              v-bind="$attrs"
              size="mini"
              placeholder="Select"
              v-loading="loading"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-row>
          <!--style="margin-top: 50px"-->
          <el-row>
            <rabbey-table3
              :columns="months"
              :data="dataReStatus"
              :loading="loading"
              :maxheight="1000"
              :paginationApi="{
                currentPage: 1,
                pageSize: 200
              }"
              :pageSizes="[200, 400, 600]"
              default-expand-all
            ></rabbey-table3>
          </el-row>
        </el-tab-pane>
        <el-tab-pane name="Actives" label="Activos">
          <Actives />
        </el-tab-pane>
        <el-tab-pane name="Passives" label="Pasivos">
          <Passives />
        </el-tab-pane>
        <el-tab-pane name="Capital" label="Capital">
          <Capital />
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
// import { Months } from "@/helpers/MonthsColumns";
import Months from "@/views/modules/Status/columns/MonthColumns";
import yearcomponent from "@/components/Global_System/YearsComponent";
import Actives from "@/views/modules/Status/balanceGerenal/Actives/Actives.vue";
import Passives from "@/views/modules/Status/balanceGerenal/Passives/Passives.vue";
import Capital from "@/views/modules/Status/balanceGerenal/Capital/Capital.vue";

export default {
  name: "BalanceGeneral",
  components: {
    yearcomponent,
    Actives,
    Passives,
    Capital
  },
  data() {
    return {
      tabName: "GnralBalance",
      months: Months,
      loading: false,
      options: [
        {
          value: "RD",
          label: "RD$"
        },
        {
          value: "US",
          label: "US$"
        }
      ],
      companysRD: [
        {
          value: 4,
          label: "Magycorp Technologies"
        },
        {
          value: 5,
          label: "Magycorp SA"
        },
        {
          value: 0,
          label: "Consolidado"
        }
      ],
      companysUSA: [
        {
          value: 4,
          label: "Magycorp Technologies"
        },
        {
          value: 5,
          label: "Magycorp SA"
        },
        {
          value: 2,
          label: "MAGYTRACK"
        },
        {
          value: 1,
          label: "TENNOS BUSINESS"
        },
        {
          value: 6,
          label: "RABBEY"
        },
        {
          value: 7,
          label: "NUPSHOP"
        },
        {
          value: 0,
          label: "Consolidado"
        }
      ],
      dataReStatus: [],
      year: 2023,
      valueCompanys: 4,
      valueMoney: "RD"
    };
  },
  mounted() {
    this.GetDataBalanceGeneral();
  },
  methods: {
    handler_year(_year) {
      this.year = _year;
      this.GetDataBalanceGeneral();
    },
    GetDataBalanceGeneral() {
      this.loading = true;

      var params = {
        option: this.valueCompanys,
        year: this.year,
        divisa: this.valueMoney
      };
      this.$http
        .get(`/api/resultsStatus/GetDataBalanceGeneral`, {
          params: params
        })
        .then((resp) => {
          this.loading = false;
          // console.logvalueMoney;
          this.dataReStatus = resp.data;
        })
        .catch(() => {
          this.loading = false;
        })
        .finally(() => (this.loading = false));
    }
  },
  watch: {
    valueCompanys() {
      this.GetDataBalanceGeneral();
    },
    year() {
      this.GetDataBalanceGeneral();
    },
    valueMoney() {
      this.GetDataBalanceGeneral();
    }
  }
};
</script>

<style scoped></style>
